function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.166 16.666h11.667v1.667H4.166v-1.667zM9.999 5.833c-.916 0-1.666.75-1.666 1.666 0 .917.75 1.667 1.666 1.667a1.667 1.667 0 000-3.333zm0-4.167c2.725 0 5.834 2.05 5.834 5.958 0 2.6-1.942 5.342-5.834 8.209-3.891-2.867-5.833-5.609-5.833-8.209 0-3.908 3.108-5.958 5.833-5.958z",
  fill: "#fff"
});

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default SvgLocation;